import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TextPreviewState } from 'owa-sxsdata';

export interface TextPreviewProps {
    className?: string;

    // onLoad is called when the preview is loaded
    // since text preview only render the text,
    // preview is "loaded" on component mount or update
    onLoad: () => void;
    viewState: TextPreviewState;
}

const styles = require('./TextPreview.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function TextPreview(props: TextPreviewProps) {
    React.useEffect(() => {
        // There was a race condition - onLoad is called before previewAttachmentInSxS is waiting for the load event
        // use requestAnimationFrame or setTimeout to delay calling onLoad
        const onLoad = () => {
            props.onLoad();
        };

        if (window?.requestAnimationFrame) {
            window.requestAnimationFrame(onLoad);
        } else {
            window.setTimeout(onLoad, 0);
        }
    });

    const mainClassNames = classNames(props.className, styles.main);

    return (
        <div
            className={mainClassNames}
            data-is-focusable={true}
            tabIndex={0}
            data-is-scrollable={true}>
            <pre
                className={classNames(
                    styles.textContent,
                    props.viewState.allowDownload ? 'allowTextSelection' : ''
                )}>
                {props.viewState.text}
            </pre>
        </div>
    );
});
